/* src/app/modules/portal/components/authorized/authorized.component.scss */
#User_identifier_target {
  padding-left: 0;
}
[screen-phone] :host-context .userNameCl {
  display: none;
}
[screen-desktop] :host-context #User_identifier_target,
[screen-desktop-large] :host-context #User_identifier_target {
  padding-left: 24px;
}
.userNameCl {
  align-self: center;
  padding-left: 5%;
  cursor: pointer;
  max-width: var(--sh-user-identifier-max-width);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 90px;
}
/*# sourceMappingURL=authorized.component.css.map */
